import { Component, input, output } from '@angular/core';

export interface ThemeDeltaRow {
  variable: string;
  label: string;
  before: string;
  after: string;
  changes: string;
  isNew: boolean;
  isRemoved: boolean;
  hasChange: boolean;
}

@Component({
  selector: 'app-theme-download-preview',
  imports: [],
  templateUrl: './theme-download-preview.component.html',
  styleUrl: './theme-download-preview.component.css',
})
export class ThemeDownloadPreviewComponent {
  // Inputs
  deltaRows = input.required<ThemeDeltaRow[]>();
  mode = input.required<'light' | 'dark'>();

  // Outputs
  modeChange = output<'light' | 'dark'>();
  confirm = output<void>();
  cancel = output<void>();

  /** Check if a value looks like a CSS color */
  isColor(value: string): boolean {
    const v = value.trim();
    return (
      /^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(v) ||
      /^rgba?\s*\(/.test(v) ||
      /^hsla?\s*\(/.test(v)
    );
  }

  onModeChange(newMode: 'light' | 'dark'): void {
    this.modeChange.emit(newMode);
  }

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
